import { CustomLink, Glide, SubTitle, Caption, styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import React from 'react';
import { defaultSlider } from '../../constants/index.es.js';
import { t } from '../../i18n.es.js';
import { useDevice } from '../../contexts/DeviceContext.es.js';
import { BlockHeader } from '../BlockHeader/BlockHeader.es.js';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const FeaturedBrands = ({
  header,
  brands,
  slider = __spreadProps(__spreadValues({}, defaultSlider), {
    perView: 4,
    showControl: true,
    gap: 20,
    autoplay: 2e3,
    dragThreshold: 1,
    swipeThreshold: 1,
    type: "carousel"
  }),
  isHeadingTitle = false
}) => {
  const { isMobile } = useDevice();
  if (!brands || !brands.length)
    return null;
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(BlockHeader, __spreadProps(__spreadValues({}, header), {
    title: header.title || t("Th\u01B0\u01A1ng hi\u1EC7u n\u1ED5i b\u1EADt"),
    isHeadingTitle
  })), isMobile && /* @__PURE__ */ React.createElement(MobileSliderWrapper, null, brands.map((brand, index) => {
    var _a;
    return /* @__PURE__ */ React.createElement(MobileSliderItem, __spreadValues({
      key: index
    }, getTrackingData({
      index,
      regionName: "topBrands",
      target: (_a = brand == null ? void 0 : brand.link) == null ? void 0 : _a.href,
      contentName: brand == null ? void 0 : brand.name,
      isTrackContent: true
    })), /* @__PURE__ */ React.createElement(CustomLink, __spreadValues({}, brand.link), /* @__PURE__ */ React.createElement(EnhancedImage, __spreadProps(__spreadValues({
      width: "auto"
    }, brand.image), {
      googleImageParams: {
        width: 400
      },
      hover: "zoom",
      borderRadius: 8,
      objectFit: "cover",
      height: 120,
      alt: header.title || t("Th\u01B0\u01A1ng hi\u1EC7u n\u1ED5i b\u1EADt")
    }))));
  })), !isMobile && /* @__PURE__ */ React.createElement(SliderWrapper, null, /* @__PURE__ */ React.createElement(Glide, __spreadValues({}, slider), brands.map((brand, index) => {
    var _a, _b;
    return /* @__PURE__ */ React.createElement(CustomLink, __spreadProps(__spreadValues({
      key: index
    }, brand.link), {
      href: (_a = brand.link) == null ? void 0 : _a.href
    }), /* @__PURE__ */ React.createElement(Card, __spreadValues({}, getTrackingData({
      index,
      regionName: "topBrands",
      target: (_b = brand == null ? void 0 : brand.link) == null ? void 0 : _b.href,
      contentName: brand == null ? void 0 : brand.name,
      isTrackContent: true
    })), /* @__PURE__ */ React.createElement(EnhancedImage, __spreadProps(__spreadValues({}, brand.image), {
      googleImageParams: {
        width: 400
      },
      hover: "zoom",
      borderRadius: 8,
      objectFit: "cover",
      height: 140,
      alt: brand.name
    })), /* @__PURE__ */ React.createElement(SubTitle, {
      level: 2,
      line: 1,
      marginTop: "s16"
    }, brand.name), brand.description && /* @__PURE__ */ React.createElement(Caption, {
      level: 1,
      weight: "regular",
      line: 1
    }, brand.description)));
  }))));
};
const Wrapper = styled.div`
  background: white;
  border-radius: 8px;
`;
const Card = styled.div`
  text-align: center;
`;
const SliderWrapper = styled.div`
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-right: 1rem;
`;
const MobileSliderWrapper = styled.div`
  display: flex;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  transform: translate3d(0, 0, 0);
`;
const MobileSliderItem = styled.div`
  flex-shrink: 0;
  margin-right: 16px;
`;

export { FeaturedBrands };
